import { FC } from 'react';
import cx from 'clsx';

import { useInitializationStep } from './useInitializationStep';

import mainStyles from '../../styles.module.css';
import styles from './styles.module.css';
import { TermsAndConditionsLink } from 'src/components/Form/TermsAndConditionsModal';
import { Icon } from 'src/components/Icon';

export const InitializationStep: FC = () => {
  const { onAcceptConsent } = useInitializationStep();

  return (
    <section className={cx(mainStyles.stepSection, styles.container)}>
      <div className={styles.contentContainer}>
        <img className={styles.logo} src="/logo.svg" alt="Playwall Logo" />

        <div className={styles.content}>
          <h2 className={styles.title}>
            PlayWall needs <br />
            permission to continue
          </h2>

          <p className={styles.consent}>
            By proceeding, you agree to the collection, use and disclosure of
            your personal data by PlayWall for the administration of this
            experience. All processing of your personal data shall be in
            accordance with
            <TermsAndConditionsLink text=" PlayWall's Personal Data Protection Policy (PDPD)." />
          </p>
        </div>

        <button className={styles.button} onClick={onAcceptConsent}>
          <span className={styles.buttonText}>I agree</span>
          <Icon className={styles.icon} name="checkMark" />
        </button>
      </div>
    </section>
  );
};
